// extracted by mini-css-extract-plugin
export default {"status-item":"ConnectionStatusPopup_status-item__r95pc","status-dot":"ConnectionStatusPopup_status-dot__Ocbd4"};